import React from 'react'
import axios from 'axios'
import {bindActionCreators} from 'redux'
import * as dataActions from '../actions/dataActions'

import { Button, Form, FormGroup, Label, Input, FormText, Container, Row, Col, CustomInput, Alert } from 'reactstrap'
import { connect } from 'react-redux';
import MyEditor from './Draft.js'

import brand from '../images/brand.png'

function sendArticle (x, article) {
  axios({
    method: 'POST',
    url: `${process.env.REACT_APP_API_URL}/content/article/`,
    data: article,
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': 'Bearer ' + sessionStorage.getItem('token')
    }
  }).then((res) => {
    x.setState({
      ...x.state,
      resCode: res.request.status
    })
  }).catch((res, err) => {
    x.setState({
      ...x.state,
      resCode: res.request.status
    })
  })
}

function tradError (x) {
  let code = x.state.resCode
  if (code === 201) { return 'Votre article a été crée avec succés!' }
  if (code === 409) { return 'Ce titre est déjà utilisé.' }
  if (code === 503) { return 'Erreur' }
  if (code === 400) { return 'Verifiez bien que tous les champs on bien été remplis...' }
}

class Create extends React.Component {
  constructor () {
    super()
    this.state = {
      article: {
        title: '',
        image: null,
        description: '',
        content: '',
        categories: [],
      },
      categories: null,
      imgPrev: '',
      resCode: null,
      errMsg: '',
      togglMsg: false
    }
    this.handleClick = this.handleClick.bind(this)
    this.handleImage = this.handleImage.bind(this)
    this.handleCategories = this.handleCategories.bind(this)
    this.handleText = this.handleText.bind(this)
  }

  componentWillMount () {
    this.setState({
      ...this.state,
      categories: this.props.categories
    })
  }

  componentDidUpdate () {
    if (this.state.article.content !== this.props.articleHTML) {
      this.setState({
        ...this.state,
        article: {
          ...this.state.article,
          content: this.props.articleHTML
        }
      })
    }
  }

  handleClick () {
    const formData = new FormData()
    let article = this.state.article
    for(let key in article) {
      formData.append(key, article[key])
    }
    sendArticle(this, formData)
    this.setState({
      ...this.state,
      togglMsg: true
    })

  }

  handleText (e) {
    this.setState({
      ...this.state,
      article: {
        ...this.state.article,
        [e.target.name]: e.target.value
      }
    })
  }

  handleCategories (e) {
    if (e.target.checked) {
      let cat = this.state.article.categories.concat(e.target.id)
      this.setState({
        ...this.state,
        article: {
          ...this.state.article,
          categories: cat
        }
      })
    } else {
      let categ = this.state.article.categories
      let index = categ.indexOf(e.target.id)
      if (index > -1) {
        categ.splice(index, 1)
        this.setState({
          ...this.state,
          article: {
            ...this.state.article,
            categories: categ
          }
        })
      }
    }
  }

  handleImage (e) {
    e.preventDefault()
    let reader = new FileReader()
    let file = e.target.files[0]

    reader.onload = () => {
      this.setState({
        ...this.state,
        imgPrev: reader.result,
        article: {
          ...this.state.article,
          image: file
        }
      })
    }
    reader.readAsDataURL(file)
  }

  render () {
    if (this.state.categories === null ) {
      return <div className={'w100p h90vh vCenter'}><div className={'w50p'}><img className={'imgResponsive'} src={brand} alt='loading img'/></div></div>
    } else {
      let categ = this.state.categories
      let itit = categ.filter(cat => cat.type === 'BOARD')
      let time = categ.filter(cat => cat.type === 'TIME')
      let global = categ.filter(cat => cat.type === 'GLOBAL')
      return (
        <div>
          <Container className={'mT-5'}>
            <Row>
              <Col>
                <h1 className={'txtcenter'}>Créer un Article</h1>
              </Col>
            </Row>
            <hr />
            <Form>
              <Row>
                <Col md={{size: 6, offset: 3}}>
                  <FormGroup>
                    <Label for='exampleText'>Titre</Label>
                    <Input type='text' name='title' id='title' onChange={this.handleText.bind(this)}/>
                  </FormGroup>
                  <FormGroup>
                    <Label for='exampleText'>Description Courte</Label>
                    <Input type='textarea' name='description' id='shortDescription' onChange={this.handleText.bind(this)}/>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col className={''} md={{size: 6, offset: 3}}>
                  <Label for='exampleFile'>Image</Label>
                  <Input type='file' name='file' onChange={this.handleImage.bind(this)} />
                  <FormText color='muted'>
                    Taille maximale: 5mb
                  </FormText>
                  <div className={'border-grey p-2 brad-5 txtcenter '}>
                    { this.state.imgPrev === '' ? null : <img className={'ofit-cover h30p w30p'} src={this.state.imgPrev} alt='preview'/>}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <h3>Catégories:</h3>
                </Col>
              </Row>
              <hr />

              {/* CATEGORY CHECKBOX SECTIONS */}
              <Row className={''}>
                <Col className={''}>
                  <FormGroup className={'hCenter'}>
                    <Label className={'font-b marker'} for='exampleCheckbox'>ITITOCA Board</Label>
                    <div>
                      { itit.map(cat => {
                        return (
                          <CustomInput name={cat.name} type='checkbox' id={cat._id}  key={cat._id} value={cat.name} inline onClick={this.handleCategories.bind(this)}>{cat.name}</CustomInput>
                        )
                      })
                      }
                    </div>
                  </FormGroup>
                </Col>
                <Col className={'vCenter'}>
                  <FormGroup>
                    <Label className={'font-b marker'} for='exampleCheckbox'>Temps</Label>
                    <div>
                      {time.map(cat => <CustomInput name={cat.name} type='checkbox' id={cat._id} key={cat._id} value='10mins' inline onClick={this.handleCategories.bind(this)}>{cat.name}</CustomInput>)}
                    </div>
                  </FormGroup>
                </Col>
                <Col className={'vCenter'}>
                  <FormGroup>
                    <Label className={'font-b marker'} for='exampleCheckbox'>Cible</Label>
                    <div>
                      {global.map(cat => <CustomInput name={cat.name} type='checkbox' id={cat._id} key={cat._id} value='Moi' inline onClick={this.handleCategories.bind(this)}>{cat.name}</CustomInput>)}
                    </div>
                  </FormGroup>
                </Col>
              </Row>
              {/* END CATEGORIES */}

              <hr />
              <Row>
                <Col>
                  <MyEditor />
                </Col>
              </Row>
            </Form>
            <hr />
            <Row className={'mB-10'}>
              <Col className={''}>
                <Button className={'w30p pT-4 pB-10'} color='success' onClick={this.handleClick.bind(this)}>POSTER</Button>
              </Col>
              <Col>
                {
                  this.state.togglMsg === true ? <Alert className={'txtcenter'} color={this.state.resCode === 201 ? 'success' : 'danger'}><i className={this.state.resCode === 201 ? 'check icon' : 'exclamation circle icon'} />{tradError(this)}</Alert> : null
                }
              </Col>
            </Row>
          </Container>
        </div>
      )
    }
  }
}

function mapStateToProps (state) {
  return {
    categories: state.data.categories,
    articleHTML: state.content.htmlContent
  }
}

function mapDispatchToProps (dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Create)

export {Create}



// WEBPACK FOOTER //
// ./src/components/CreateContent.js